import * as React from "react";
import { twMerge } from "tailwind-merge";

export interface InputBoxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  placeholder?: string;
  className?: string;
  wrapperClassName?: string;
  disabled?: boolean;
  required?: boolean;
  showIcon?: boolean;
  iconSrc?: string;
  onIconClick?: () => void;
  iconMinimal?: boolean;
}

const InputBox = React.forwardRef<HTMLInputElement, InputBoxProps>(
  (
    {
      label,
      placeholder = "입력",
      className = "",
      wrapperClassName = "",
      disabled = false,
      required = false,
      showIcon = false,
      iconSrc = "/icons/searchBlack.svg",
      onIconClick,
      iconMinimal = false,
      readOnly,
      ...props
    },
    ref
  ) => {
    const hasLabel = label !== undefined;
    const iconClickable = !!onIconClick && !disabled;

    return (
      <div className={twMerge("relative", wrapperClassName)}>
        {/* Label - 속성 존재 시에만 영역 생성 */}
        {hasLabel && (
          <div className="h-6 mb-1">
            <label className="block text-base font-normal text-[#414651]">
              {required && <span className="text-red-500 mr-1">*</span>}
              {label}
            </label>
          </div>
        )}

        {/* Input Box */}
        <div className="relative">
          <input
            ref={ref}
            placeholder={placeholder}
            disabled={disabled}
            required={required}
            readOnly={readOnly}
            className={twMerge(
              "w-full border border-[#CCCCCC] rounded-md px-2 py-2",
              "focus:outline-none focus:ring-2 focus:ring-[#55b938] focus:border-[#55b938]",
              disabled ? "bg-[#F6F6F6] cursor-not-allowed text-gray-500" : "bg-white cursor-text",
              readOnly ? "bg-[#F5F5F5] cursor-default" : "",
              "text-[#333333] placeholder:text-[#AAAAAA]",
              showIcon && "pr-10",
              className
            )}
            {...props}
          />

          {/* Icon */}
          {showIcon && (
            <button
              type="button"
              disabled={!iconClickable}
              tabIndex={iconClickable ? 0 : -1}
              aria-disabled={!iconClickable}
              onClick={iconClickable ? onIconClick : undefined}
              className={`
                absolute right-0 top-0 bottom-0 w-10 flex items-center justify-center rounded-r-md
                ${iconMinimal ? "bg-transparent border-0" : "bg-[#F6F6F6] border border-[#CCCCCC]"}
                ${iconClickable ? "cursor-pointer hover:opacity-70" : "pointer-events-none cursor-not-allowed"}
              `}
            >
              <img src={iconSrc} alt="" className={disabled ? "opacity-50" : ""} />
            </button>
          )}
        </div>
      </div>
    );
  }
);

InputBox.displayName = "InputBox";

export { InputBox };
